var path = 'src/app/patients/cohorts/cohorts.html';
var html = "<h1 class=page-header>Cohorts</h1> <div patient-cohorts-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/cohorts/cohorts.html
 ** module id = 395
 ** module chunks = 0
 **/